<div class="generic-container-wrapper" [ngClass]="headerClass">
    <div class="generic-container-title">
        <div class="header-ctrl-wrapper">
            <div class="header-ctrl d-flex justify-content-between align-items-center">
                <div class="header-ctrl-txt" [innerHtml]="headerTitle | trustAsHtml"></div>
            </div>
        </div>
    </div>

    <!--Content-->
    <div class="betstation-error-message" [innerHtml]="content | trustAsHtml"></div>

    <!--CTA-->
    <div class="btn-container">
        <ng-content select="[actions]" />
    </div>
</div>
